import React from 'react';
import { Box } from '@saviynt/design-system';

import { type invertedMessages } from '../../../../constants/messages';
import FormInputText from '../TextInput/TextInput';

import './FormBuilder.css';

export interface InputFields {
  type: FieldTypes | null;
  label: string | null;
  pattern: string | null;
  password: boolean;
  required: boolean;
  guideMe: boolean;
  inputDescription: string | null;
  payloadAtrributeName: string;
  attributeName: string;
  inputValueStatus: (status: {
    attributeName: string;
    value: string;
    hasError: boolean;
    payloadAtrributeName: string;
  }) => void;
  fieldDisabled?: boolean;
  defaultValue?: string;
}

interface FormBuilderProps {
  fields: InputFields[];
  className?: string;
}

export enum FieldTypes {
  TextInputSingleLine = 'TextField',
}

FormBuilder.defaultProps = {
  className: '',
};

/**
 * Form Builder component
 */
function FormBuilder({ fields, className }: FormBuilderProps) {
  const handleInputField = (value: FieldTypes | null, data: InputFields) => {
    let element = null;

    if (value === FieldTypes.TextInputSingleLine) {
      element = (
        <FormInputText
          label={data.label as keyof typeof invertedMessages}
          defaultValue={data.defaultValue}
          pattern={data.pattern}
          password={data.password}
          required={data.required}
          guideMe={data.guideMe}
          fieldDescription={data.inputDescription}
          payloadAtrributeName={data.payloadAtrributeName}
          attributeName={data.attributeName}
          inputValueStatus={data.inputValueStatus}
          fieldDisabled={data.fieldDisabled ?? false}
        />
      );
    }

    return element;
  };

  return (
    <Box className={className}>
      {fields.map((field) => (
        <Box key={field.attributeName}>
          {handleInputField(field.type, field)}
        </Box>
      ))}
    </Box>
  );
}

export default FormBuilder;
